var FOCUS_TYPE;
(function (FOCUS_TYPE) {
  FOCUS_TYPE["MOUSE"] = "focus";
  FOCUS_TYPE["TAB"] = "tab-focus";
  FOCUS_TYPE["NONE"] = "idle";
})(FOCUS_TYPE || (FOCUS_TYPE = {}));

export { FOCUS_TYPE as F };
